<template>
  <b-modal :active.sync="active_" has-modal-card @close="close">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">Create Access Key</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Name">
          <b-input v-model="form.name"></b-input>
        </b-field>
        <b-field label="Expiry">
          <b-input v-model="form.expiry" type="date"></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <b-button @click="close">Cancel</b-button>
        <b-button :loading="loading" @click.prevent="generateKey">
          Generate
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { KeyService } from "@/services/key.service";

export default {
  keyService: KeyService,
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    active_: false,
    form: {
      name: "",
      expiry: "",
    },
    loading: false,
  }),
  watch: {
    active(active) {
      this.active_ = active;
    },
    active_(active) {
      this.$emit("update:active", active);
    },
  },
  methods: {
    clearForm() {
      this.form = {
        name: "",
        expiry: "",
      };
    },
    close() {
      this.clearForm();
      this.$emit("close");
      this.active_ = false;
    },
    async generateKey() {
      try {
        this.loading = true;
        const subdomain =
          window.location.hostname.split(".").length > 2
            ? window.location.hostname.split(".")[0]
            : null;
        await KeyService.create({
          subdomain: subdomain || undefined,
          name: this.form.name || undefined,
          type: "API_KEY",
          expiry: this.form.expiry || undefined,
        });
        this.$buefy.toast.open({
          message: "Access key has been generated.",
          type: "is-info",
          position: "is-top-right",
        });
        this.$emit("generate");
        this.close();
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Key/KeyFormModal.vue